
import { defineComponent, computed, onMounted, ref } from "vue";
import TopicList from "@/components/search/TopicList.vue";
import CommonRecipeList from "@/components/commonRecipe/CommonRecipeList.vue";
import RecommendListTitle from "@/components/common/RecommendTitle.vue";
import SearchInputView from "@/components/search/SearchInputView.vue";
import CommonDialog from "@/components/common/CommonDialog.vue";
import store from "@/store";
import router from "@/router";
import { useApiErrorHandler } from "@/use/use-api-error-handler";
import { useApiErrorDialog } from "@/use/use-api-error-dialog";
import { PAGE_ID } from "@/const/log-const";
import { SEARCH_SORT_TYPE, SEARCH_RECIPE_TYPE } from "@/types/search";
import NativeClient, { TitleInfo } from "@/client/native-client";
import { createRecipeToCommonRecipes } from "@/utils/search-util";
import CommonUtil from "@/utils/common-utils";
import { BeaconLogInfo } from "@/types/common";
export default defineComponent({
  name: "RecipeSearchPage",
  components: {
    TopicList,
    CommonRecipeList,
    RecommendListTitle,
    SearchInputView,
    CommonDialog
  },
  emits: ["on-click"],
  setup() {
    const limitCount = -1;
    const keyword = ref("");
    NativeClient.setTitle(new TitleInfo(true, "レシピ"));
    CommonUtil.scroll({ top: 0, left: 0 });
    /**
     * レシピリストを取得する
     */
    const getRecipes = async () => {
      store.dispatch("common/startLoading");
      store.dispatch("search/updateProducts", null);
      await Promise.all([NativeClient.getApiParams()]).then(result => {
        const apiParams = store.getters["common/getApiBaseParams"];
        NativeClient.sendDebugLog(
          "RecipeSearchPage getRecipes apiParams=" + JSON.stringify(apiParams)
        );
        if (apiParams.token) {
          Promise.all([
            store.dispatch("search/getRankingRecipes"),
            store.dispatch("search/getProducts")
          ]).then(result => {
            store.dispatch("common/stopLoading");
          });
        } else {
          Promise.all([
            store.dispatch("search/getRankingRecipes")
          ]).then(result => {
            store.dispatch("common/stopLoading");
          });
        }
      });
    };

    /**
     * レシピリストの取得を実行する
     */
    const execute = async () => {
      getRecipes();
    };

    /**
     * コンポーネントがマウントされたときに通知される
     */
    onMounted(() => {
      execute();
    });

    /** APIリクエスト時のエラーハンドル */
    const {
      handleApiError,
      getApiErrorTitle,
      getApiErrorMessage
    } = useApiErrorHandler();

    /** ダイアログの制御 */
    const { closeDialog } = useApiErrorDialog();

    // 人気レシピリストを取得(TODO)
    const rankingRecipes = computed(() => {
      const result = store.getters["search/getRankingRecipes"];
      if (result != null && result.recipes != null) {
        const commonRecipe = createRecipeToCommonRecipes(result.recipes);
        NativeClient.sendDebugLog(
          "RecipeSearchPage computed rankingRecipes " +
            JSON.stringify(commonRecipe)
        );
        const beaconLogInfo = new BeaconLogInfo(PAGE_ID.RECIPE_SEARCH_TOP, null, new Array<string>());
        NativeClient.sendViewedLog(beaconLogInfo);
        return commonRecipe;
      }
      NativeClient.sendDebugLog(
        "RecipeSearchPage computed rankingRecipes empty"
      );
      return null;
    });

    /**
     * レシピカテゴリー取得APIの呼び出しをリトライする
     */
    const retryGetRecipes = () => {
      // ダイアログを閉じる
      closeDialog();
      getRecipes();
    };

    /**
     * 選択されたレシピをNativeに通知する
     */
    const selectRecipe = (id: number, type: string, objectId: string) => {
      NativeClient.sendDebugLog(
        "SearchPage selectRecipe id=" + id + " type=" + type
      );
      const viewedItem = Array<string>();
      viewedItem.push(String(id));
      const beaconLogInfo = new BeaconLogInfo(PAGE_ID.RECIPE_SEARCH_TOP, objectId, viewedItem);
      NativeClient.sendClickedActionLog(beaconLogInfo);
      NativeClient.transitionReceipDetail(id, type);
    };

    const selectRecipeRanking = (id: number, type: string) => {
      selectRecipe(id, type, "btn_1_G-05_RankingRecipe");
    };

    /**
     * 選択されたレシピ種別からレシピ一覧画面を表示(TODO)
     */
    const clickSeeMore = (type: string) => {
      NativeClient.sendDebugLog("clickSeeMore type=" + type);
      switch (type) {
        case SEARCH_RECIPE_TYPE.RANKING:
        case SEARCH_RECIPE_TYPE.TOPIC:
          router.push(`/search-recommend?type=` + type);
          break;
      }
    };

    const setFocusInputView = () => {
      router.push(
        "search-detail?top=1&keyword=&sort=" + SEARCH_SORT_TYPE.MATCH
      );
    };

    return {
      rankingRecipes,
      limitCount,
      clickSeeMore,
      handleApiError,
      getApiErrorTitle,
      getApiErrorMessage,
      closeDialog,
      getRecipes,
      retryGetRecipes,
      SEARCH_RECIPE_TYPE,
      setFocusInputView,
      keyword,
      selectRecipeRanking
    };
  }
});
